import { createListFilters, IOption } from '../../../../../components'

export type EmpresasFilters = {
  empresa: string
  status?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<EmpresasFilters>({
  empresa: '',
  status: undefined,
})
